import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
import { PageDto } from 'src/app/models/page.model';

export interface RoleDTO {
  id?: string;
  name:  string; // slug
  label?: string;        // etiqueta legible
  description?: string;  // descripción o lista serializada 
  active?: boolean;
  generalRoleId: number;
}

export interface GeneralRoleDTO {
  id: number;
  name: string;
  value: number;
}

export interface CreateRoleRequest {
  name: string;               // Required, 2-50 chars
  description?: string | null; // Optional, 0-255 chars
  permissionLevel?: number;   // Optional
  generalRoleId?: number;     // Optional
}

@Injectable({ providedIn: 'root' })
export class RolesService {
  constructor(private api: ApiService) { }

  list(params?: any): Observable<RoleDTO[]> {
    return this.api
      .get<PageDto<RoleDTO> | RoleDTO[]>('admin/roles', params)
      .pipe(
        map((res: any) => {
          if (Array.isArray(res)) return res as RoleDTO[];
          if (res && Array.isArray(res.items)) return res.items as RoleDTO[];
          return [] as RoleDTO[];
        })
      );
  }

  generalRoles(params?: any): Observable<GeneralRoleDTO[]> {
    return this.api
      .get<PageDto<GeneralRoleDTO> | GeneralRoleDTO[]>(`admin/roles/general-roles`, params)
      .pipe(
        map((res: any) => {
          if (Array.isArray(res)) return res as GeneralRoleDTO[];
          if (res && Array.isArray(res.items)) return res.items as GeneralRoleDTO[];
          return [] as GeneralRoleDTO[];
        })
      );
  }

  listPage(params?: any): Observable<PageDto<RoleDTO>> {
    var result = this.api.get<PageDto<RoleDTO>>('admin/roles', params);
    return result;
  }

  get(id: string): Observable<RoleDTO> {
    var result = this.api.get<RoleDTO>(`admin/roles/${id}`);
    return result;
  }
  create(body: CreateRoleRequest): Observable<RoleDTO> {
    var result = this.api.post<RoleDTO>('admin/roles', body);
    return result;
  }
  update(id: string, body: Partial<RoleDTO>): Observable<RoleDTO> {
    var result = this.api.put<RoleDTO>(`admin/roles/${id}`, body);
    return result;
  }
  delete(id: string): Observable<void> {
    var result = this.api.delete<void>(`admin/roles/${id}`);
    return result;
  }
}

